import FormInput from "../UI/FormInput";
import { useTranslation } from "react-i18next";

const DirectoryAttribute = () => {
  const { t } = useTranslation("form");
  return (
    <FormInput
      label={t("directoryAttribute")}
      placeholder={t("directoryAttribute")}
      id="directory_attribute"
      type="text"
      autoComplete="directory attribute"
      required={true}
      helperText={null}
      attr={{ maxLength: 50 }}
    />
  );
};

export default DirectoryAttribute;